import React from 'react';
import PropTypes from 'prop-types';
import {  ButtonContainer, CalendarHeader, CalendarWrapper, ConfirmVisitText, StyledModal, TourButton } from './styles';
import { Modal } from 'react-bootstrap';

const TourSkippedPopup = ({ showModal, onClose }) => (
  <StyledModal show={showModal} width="450px">
    <div className="modal-content-padding">
      <CalendarHeader>
        <div className="left-content">
          {/* <div className="icon">ℹ️</div> */}
          <div>Tour Skipped</div>
        </div>
        {/* <div className="close-icon" onClick={onClose}>
          {AdminCloseIcon()}
        </div> */}
      </CalendarHeader>
      
      <CalendarWrapper>
        <ConfirmVisitText>
         Want to explore later? All product tours are available in your Profile
        </ConfirmVisitText>
      
      </CalendarWrapper>
    </div>

    <Modal.Footer style={{borderTop:'none', display:'flex', padding:'0', justifyContent:'center'}}>
      <ButtonContainer>
        <TourButton primary onClick={onClose}>
          Thank You
        </TourButton>
      </ButtonContainer>
    </Modal.Footer>
  </StyledModal>
);

TourSkippedPopup.propTypes = {
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default TourSkippedPopup;
